import { useMemo } from 'react';
import { useGetRulesQuery } from '../../app/api';
import { useAppSelector } from '../../app/hooks';
import { RuleSearch } from './RuleSearch';
import { RuleCard } from './RuleCard';

export function RulesSidebar() {
  const { data } = useGetRulesQuery();
  const search = useAppSelector((s) => s.rulesUi.search);
  const severityFilter = useAppSelector((s) => s.rulesUi.severityFilter);
  const runningCount = useAppSelector(
    (s) => Object.values(s.detection.runtime).filter((r) => r.status === 'running').length,
  );

  const rules = data?.items ?? [];
  const visible = useMemo(() => {
    const q = search.trim().toLowerCase();
    return rules.filter((r) => {
      if (severityFilter && r.severity !== severityFilter) return false;
      if (q && !`${r.name} ${r.description}`.toLowerCase().includes(q)) return false;
      return true;
    });
  }, [rules, search, severityFilter]);

  return (
    <div
      style={{
        borderRight: '1px solid var(--border)',
        background: 'var(--surface-panel)',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }}
    >
      {/* header */}
      <div
        style={{
          padding: '16px 18px 12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.3 }}>
          <span className="eyebrow" style={{ fontSize: 13, fontWeight: 600, letterSpacing: 1.5 }}>
            Detection Rules
          </span>
          <span style={{ fontSize: 12, color: 'var(--text-dim)' }}>
            <span className="mono" style={{ color: 'var(--ok)', fontWeight: 600 }}>{runningCount}</span> of{' '}
            <span className="mono">{data?.total ?? 0}</span> running
          </span>
        </div>
      </div>

      <RuleSearch />

      {/* list */}
      <div
        className="scrl"
        style={{
          flex: 1,
          overflowY: 'auto',
          padding: '2px 12px 12px',
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          minHeight: 0,
        }}
      >
        {visible.map((rule) => (
          <RuleCard key={rule.id} rule={rule} />
        ))}
        {visible.length === 0 && (
          <div style={{ color: 'var(--text-dim)', fontSize: 12, padding: '12px 4px' }}>
            No rules match.
          </div>
        )}
      </div>
    </div>
  );
}
